import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useSelector } from 'react-redux';
import { selectIsMobile } from 'redux/mode/reducers';
import { RootReducer } from 'redux/reducers';
import * as S from './styles';

interface MarkdownTextProps {
	children: string;
	onContextMenu?: (e: React.MouseEvent) => void;
}

const MarkdownText = ({ children, onContextMenu }: MarkdownTextProps) => {
	const isMobile = useSelector((r: RootReducer) => selectIsMobile(r.mode));

	// Convert bullet point characters to markdown format
	// Convert • to - for proper markdown bullet lists
	const processedContent = children.replace(/^• /gm, '- ');

	return (
		<S.MarkdownContent onContextMenu={onContextMenu} isMobile={isMobile}>
			<ReactMarkdown>{processedContent}</ReactMarkdown>
		</S.MarkdownContent>
	);
};

export default MarkdownText;
